import { Routes, Route, HashRouter } from "react-router-dom";

import Sliders from "./pages/Sliders";
import NinOpenAccount from "./pages/NINOpenAccount";

function App() {
  return (
    <div>
      <HashRouter>
        <Routes>
          <Route path="/" element={<NinOpenAccount />} />
          <Route path="/nin-open-account" element={<Sliders />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
